export enum ParticipantRole {
  TeamLead = 1,
  TeamMember = 2,
  OperationsRepresentative = 3,
  FinalApprover = 4,
}
